import {RsDocumentTemplateGroup} from "./dto/RsDocumentTemplateGroup";
import {Response} from "./dto/Response";
import {AxiosError, AxiosResponse} from "axios";
import apiJson from "../config/api-json";
import {getUserInfo} from "./APIUtils";

export class DocumentTemplateGroupAPI {

    baseUrl: string = "/retrieve-document-template-group"

    async retrieveDocumentTemplateGroupsByVerificationId(verificationId: string): Promise<RsDocumentTemplateGroup[]> {
        let token = localStorage.getItem("next-step")
        const config = await getUserInfo(verificationId, token)
        try {
            const response: AxiosResponse<Response<RsDocumentTemplateGroup[]>> = await apiJson.get(
                `${this.baseUrl}/verification/${verificationId}`,
                config
            )
            return response.data.data
        } catch (error: any) {
            if (error instanceof AxiosError) {
                if (error.status !== 412) {
                    throw new Error(`retrieveDocumentTemplateGroupsByVerificationId: ${error.status}`)
                }
                return []
            } else {
                throw error
            }
        }

    }

}